// Knowledge-base documents. An uploaded PDF comes back in the same shape the
// browser already holds for a seeded document, so it can be used as a block
// source immediately.
import type { KbDocument } from "../types/index.js";
import { requestJson } from "./http.js";

export type { KbChunk, KbDocument } from "../types/index.js";

export function listDocuments(): Promise<KbDocument[]> {
  return requestJson("/api/documents");
}

// XHR rather than fetch: only XHR reports upload progress, which a 25 MB
// scan needs. The browser sets the multipart boundary itself.
export function uploadDocument(file: File, category: string, origin: string,
                               onProgress?: (percent: number) => void): Promise<KbDocument> {
  const body = new FormData();
  body.append("file", file);
  body.append("category", category);
  body.append("origin", origin);

  return new Promise((resolve, reject) => {
    const request = new XMLHttpRequest();
    request.open("POST", "/api/documents");
    request.upload.addEventListener("progress", event => {
      if (event.lengthComputable) onProgress?.(Math.round((event.loaded / event.total) * 100));
    });
    request.addEventListener("load", () => {
      let payload = null;
      try { payload = JSON.parse(request.responseText); } catch { /* server sent no JSON */ }
      if (request.status >= 200 && request.status < 300) resolve(payload as KbDocument);
      else reject(new Error(payload?.error || `Request failed (HTTP ${request.status})`));
    });
    request.addEventListener("error", () => reject(new Error("Network error")));
    request.addEventListener("abort", () => reject(new Error("Upload cancelled")));
    request.send(body);
  });
}
